import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createOrganizationRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/organization/organization",
    component: lazyRouteComponent(
      () => import("pages/organization/organization"),
    ),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/organization/organization/$id",
    component: lazyRouteComponent(
      () => import("pages/organization/organization/$id"),
    ),
  }),
];
